import { Link } from "gatsby";
import Ratio from "react-bootstrap/Ratio";
import * as React from 'react';
export default {
  Link,
  Ratio,
  React
};